var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { Component, Fragment } from 'react';
import { ThemeConfig } from 'docz';
import lighten from 'polished/lib/color/lighten';
import Edit from 'react-feather/dist/icons/edit-2';
import styled, { css } from 'react-emotion';
import { ButtonLink } from './Button';
import { GithubLink, Sidebar, Main, Header } from '../shared';
import { get } from '@utils/theme';
const Wrapper = styled('div') `
  flex: 1;
  color: ${get('colors.text')};
  background: ${get('colors.background')};
  min-width: 0;
`;
const fullContainerStyles = css `
  @media (min-width: 0px) {
    height: 100%;
    max-width: 100%;
    min-height: 100%;
    padding: 0;
    width: 100%;
  }
  & > div {
    height: 100%;
    overflow-y: auto;
  }
`;
export const Container = styled('div') `
  box-sizing: border-box;
  margin: 0 auto;
  ${(p) => p.fullcontainer && fullContainerStyles};
`;
const EditPage = styled(ButtonLink.withComponent('a')) `
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  padding: 2px 8px;
  margin: 8px;
  border-radius: ${get('radii')};
  border: 1px solid ${get('colors.border')};
  opacity: 0.7;
  transition: opacity 0.4s;
  font-size: 14px;
  color: ${get('colors.text')};
  text-decoration: none;
  text-transform: uppercase;

  &:visited {
    color: ${get('colors.text')};
  }

  &:hover {
    opacity: 1;
    background: ${p => lighten(0.1, p.theme.docz.colors.border)};
  }

  ${p => p.theme.docz.mq({
    visibility: ['hidden', 'hidden', 'visible'],
    top: [0, -60, 10],
    right: [0, 0, 32],
})};
`;
const EditIcon = styled(Edit) `
  margin-right: 5px;
`;
const MDXcontent = styled.div `
  & > div {
    background: #fff;
    padding: 1px 40px 20px;
    margin: 40px;
    ${p => p.theme.docz.mq({
    margin: ['30px', '40px'],
    padding: ['1px 30px 20px', '1px 40px 20px'],
})};
    &:empty {
      display: none;
    }
  }
`;
export class Page extends Component {
    componentDidMount() {
        this.scrollToAnchor();
    }
    render() {
        const { children, doc: { link, fullpage, fullcontainer, edit = true, source, name, menu, subtitle, pageHeader = true, }, } = this.props;
        const content = (React.createElement(Fragment, null,
            (link || source) &&
                edit && (React.createElement(EditPage, { href: link || source, target: "_blank" },
                React.createElement(EditIcon, { width: 14 }),
                " Edit page")),
            pageHeader && (React.createElement(Header, { name: name, menu: menu, subtitle: subtitle })),
            React.createElement(MDXcontent, null, children)));
        return (React.createElement(ThemeConfig, null, (_a) => {
            var { repository } = _a, config = __rest(_a, ["repository"]);
            return (React.createElement(Main, { config: config },
                repository && React.createElement(GithubLink, { repository: repository }),
                !fullpage && React.createElement(Sidebar, null),
                React.createElement(Wrapper, null, fullpage ? (content) : (React.createElement(Container, { fullcontainer: fullcontainer }, content)))));
        }));
    }
    scrollToAnchor() {
        if (location.hash) {
            setTimeout(() => {
                let timeoutId = null;
                const observer = new MutationObserver((mutations, me) => {
                    const id = location.hash.substring(1);
                    const el = document.getElementById(id);
                    if (el) {
                        el.scrollIntoView();
                        me.disconnect();
                        clearTimeout(timeoutId);
                    }
                    timeoutId = setTimeout(() => {
                        me.disconnect();
                    }, 10000);
                });
                // start observing
                observer.observe(document, {
                    childList: true,
                    subtree: true,
                });
            }, 0);
        }
    }
}
//# sourceMappingURL=data:application/json;base64,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